<ion-item>
  <ion-label>
    <p>
      <span class="plate-number">{{ vehicle().plateNumber }}</span> {{ `vehicleType.${vehicle().type}` | translate }}
    </p>
  </ion-label>

  @if (canManageVehicle()) {
    <lib-vehicle-delete-action
      slot="end"
      [vehicle]="vehicle()"
    ></lib-vehicle-delete-action>
    <lib-vehicle-edit-action
      slot="end"
      [vehicle]="vehicle()"
    ></lib-vehicle-edit-action>
  }
</ion-item>
